import React, { Component } from 'react'
import { withStyles, Card, CardHeader, Avatar, Typography, CardContent, Grid, TextField, FormControl, InputLabel, Select, OutlinedInput, MenuItem, CardActions, Button } from '@material-ui/core';
import Add from '@material-ui/icons/Add'
import Rich from '../CO/Rich';
import Snack from '../../Snackbar/Snack';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { GetData, DeleteData, PutData } from '../../../api/service';
import FileUpload from '../../AddNew/FileUpload';

const styles = theme => ({
    textField: {
        width: '100%'
    },
    formControl: {
        width: '100%',
        marginTop: theme.spacing.unit * 2
    }
})

class EditNewGallery extends Component {

    state = {
        id: '',
        dept_code: '',
        year: '',
        activity: '',
        image: [],
        departments: [],
        isLoaded: true,
        open: false,
        message: '',
        edit: false
    }

    __loadData() {
        let data = this.props.history.location.state;
        //console.log(data)
        this.setState({
            ...data,
            edit: true,
            isLoaded: true,


        })
    }

    componentDidMount() {
        // load edit data

        GetData(`/getdepartments`)
            .then((resp) => {
                this.setState({
                    departments: resp,
                    isLoaded: true
                }, () => this.__loadData())
            })


    }

    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) {
            this.__loadData()
        }
    }


    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleRichChange = (name, data) => {
        this.setState({
            [name]: data
        })
    }

    onSetFile = (data) => {
        //console.log(data)
        this.setState({
            image: data
        })
    }

    onSubmit = (e) => {
        e.preventDefault();

        let data = {
            ...this.state
        }

        //console.log(data);


        PutData(`/${this.props.apikey}/${this.state.id}/editgallery`, data)
            .then((resp) => {
                //console.log(resp)
                this.setState({
                    open: true,
                    message: resp
                })
            }).then(() => {
                setTimeout(() => this.props.history.replace('/gallery/view'), 2000)
                
            })

    }

    deleteNotice = () => {
        let id = this.state.id;

        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure to do this.',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.confirmDeleteNotice(id)
                },
                {
                    label: 'No'
                }
            ]
        })

    }

    confirmDeleteNotice = (id) => {
        DeleteData(`/${this.props.apikey}/${id}/deletegallery`)
            .then((resp) => {
                console.log(resp)
                this.setState({
                    open: true,
                    message: resp
                })
            }).then(() => {
                this.props.history.replace('/gallery/view')
            })
    }

    render() {
        let { classes } = this.props;
        return (
            <div>

                {this.state.open ?
                    <Snack
                        open={this.state.open}
                        handleClose={() => {
                            this.setState({
                                open: false,
                                message: ''
                            })
                        }}
                        message={this.state.message}
                    />

                    : null}
                <form onSubmit={this.onSubmit}>
                    <Card>
                        <CardHeader
                            avatar={
                                <Avatar>
                                    <Add />
                                </Avatar>
                            }
                            title={
                                <Typography
                                    variant="h6"
                                >
                                    Edit Gallery
                                </Typography>
                            }
                        />
                        <CardContent>
                            <Grid container spacing={24}>
                                <Grid item lg={12} sm={12}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel >
                                            Department Code
                    </InputLabel>
                                        <Select
                                            value={this.state.dept_code}
                                            onChange={this.handleChange}
                                            input={
                                                <OutlinedInput labelWidth={200} name="posted_as" />
                                            }
                                            required={true}
                                            name="dept_code"

                                        >
                                            <MenuItem value="">
                                                <em>None</em>
                                            </MenuItem>
                                            <MenuItem value="COLLEGE">College Gallery</MenuItem>
                                            {this.state.departments.map((el, index) =>
                                                <MenuItem key={index} value={el.web_dept_code}>{el.dept_name}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {/* <Grid item lg={12} sm={12}>
                                    <TextField
                                        id="outlined-multiline-flexible"
                                        label="Year"
                                        fullWidth
                                        multiline
                                        rowsMax="4"
                                        name="year"
                                        value={this.state.year}
                                        onChange={this.handleChange}
                                        variant="outlined"

                                    />
                                </Grid> */}
                                <Grid item lg={12} sm={12}>
                                    <Typography
                                        variant="h6"
                                    >
                                        Description
                  </Typography>
                                    {this.state.edit ? (
                                        <Rich
                                            placeholder="Description....."
                                            onChange={this.handleRichChange.bind(this, 'description')}
                                            edit={this.state.description}
                                        />
                                    ) : null}
                                </Grid>

                                <Grid item lg={12} sm={12} md={12} xs={12}>
                                    {this.state.edit ? <FileUpload
                                        dp={this.state.image}
                                        apikey={this.props.apikey}
                                        type={`DEPT_GALLERY`}
                                        setDp={this.onSetFile.bind(this)}
                                    /> : null}
                                </Grid>



                            </Grid>
                        </CardContent>

                        <CardActions>
                            <Button
                                variant="outlined"
                                color="primary"
                                type="submit"
                            >
                                Update
            </Button>

                            <Button
                                variant="outlined"
                                color="primary"
                                type="button"
                                onClick={this.deleteNotice}
                            >
                                Delete
            </Button>
                        </CardActions>

                    </Card>

                </form>

            </div>
        )
    }
}

export default withStyles(styles)(EditNewGallery)


// WEBPACK FOOTER //
// ./src/Components/Department/Gallery/EditNewGallery.js